import { Message } from "./types";

/**
 * 대화방 정보
 */
export interface Conversation {
  id: string; // smallChatKey와 동일 (예: "conv_1_3_5")
  participantIds: number[]; // 정렬된 참여자 ID 배열
  participantNames: string[]; // 표시용 이름
  lastMessage?: Message;
  unreadCount: number;
  createdAt: number;
}

/**
 * 대화방 동기화 정보 (localStorage 저장용)
 */
export interface ConversationSyncInfo {
  conversationKey: string;
  lastReadIndex: number;
}

/**
 * 대화방 ID 생성 (그룹 유일성 보장)
 * 참여자 ID를 정렬하여 동일한 멤버 조합은 항상 같은 ID를 생성
 *
 * @param userIds 참여자 ID 배열
 * @returns 대화방 ID (예: "conv_1_3_5")
 *
 * @example
 * generateConversationKey([3, 1]) → "conv_1_3" (1:1 귓속말)
 * generateConversationKey([5, 1, 3]) → "conv_1_3_5" (그룹 채팅)
 * generateConversationKey([1, 3]) === generateConversationKey([3, 1]) → true
 */
export const generateConversationKey = (userIds: number[]): string => {
  const sorted = [...userIds].sort((a, b) => a - b);
  return `conv_${sorted.join('_')}`;
};

/**
 * 공개 채팅 키 (빈 문자열)
 */
export const PUBLIC_CHAT_KEY = "";
